/* eslint-disable react/prop-types */
import { Card, Form } from "antd";
import { Formik } from "formik";
import toast from "react-hot-toast";
import classNames from "classnames";

import { renewPasswordWithCurrentPasswordSchema } from "../../validators/authValidators";
import { updateUserPassword } from "../../services/authService";
import PasswordInput from "../Inputs/PasswordInput";
import FormButton from "../Buttons/FormButton";

const ChangePassword = ({ user }) => {
  const onSubmit = async (payload, resetForm) => {
    try {
      const { data } = await updateUserPassword(user?.id, payload);

      if (data) {
        toast.success("Password changed successfully");
        resetForm();
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.error ?? "Failed to change password");
    }
  };

  return (
    <Card
      className="rounded-2xl shadow-sm bg-white"
      title={
        <div className="flex flex-col gap-1 py-2">
          <h2 className="text-lg font-semibold text-gray-800">
            Change Password
          </h2>
          <p className="text-sm font-light text-gray-500">
            For security, we recommend using a strong, unique password.
          </p>
        </div>
      }
    >
      <Formik
        initialValues={{
          current_password: "",
          password: "",
          password_confirmation: "",
        }}
        enableReinitialize
        validationSchema={renewPasswordWithCurrentPasswordSchema}
        onSubmit={(values, { resetForm }) => {
          onSubmit(values, resetForm);
        }}
      >
        {({ values, handleChange, handleBlur, errors, submitForm }) => (
          <Form className="space-y-4 px-4 py-4">
            <PasswordInput
              name="current_password"
              title="Current Password"
              placeholder="Enter current password"
              type="password"
              requiredField={true}
              errors={errors}
              values={values}
              handleBlur={handleBlur}
              handleChange={handleChange}
            />

            <PasswordInput
              name="password"
              title="New Password"
              placeholder="Enter new password"
              type="password"
              requiredField={true}
              errors={errors}
              values={values}
              handleBlur={handleBlur}
              handleChange={handleChange}
            />

            <PasswordInput
              name="password_confirmation"
              title="Confirm Password"
              placeholder="Confirm new password"
              type="password"
              requiredField={true}
              errors={errors}
              values={values}
              handleBlur={handleBlur}
              handleChange={handleChange}
            />

            <div className="pt-3 flex justify-end">
              <FormButton
                type="primary"
                text="Update Password"
                loadingText="Saving..."
                onClick={submitForm}
              />
            </div>
          </Form>
        )}
      </Formik>
    </Card>
  );
};

export default ChangePassword;
